export default __webpack_public_path__ + "static/media/2.3c51ec68.jpeg";